import React, { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { useBaseContext } from 'context/base'
import TemplateAdmin from 'component/admin/TemplateAdmin'
import { Container, Header } from 'component/template'
import ModalContentSubmapel from './modal-content-submapel'
import LoadingSpinner from 'component/loading'
import BaseSelect from 'component/select/BaseSelect'
import Select from 'react-select'

export default function KelolaShareSubmapel() {
  /* ====================================== Consume Context ===================================== */
  const { getRequest, postRequest } = useBaseContext()

  /* =================================== Consume Local Storage ================================== */
  const role_active = JSON.parse(localStorage.getItem('role_active'))

  const location = useLocation()
  const destinationClassId = new URLSearchParams(location.search).get('destination_class_id')
  const isPopUp = new URLSearchParams(location.search).get('is_pop_up')

  /* ======================================= Local States ======================================= */
  const [allClassProfiles, setAllClassProfiles] = useState([])
  const [allCategory, setAllCategory] = useState([])
  const [categoryId, setCategoryId] = useState('')
  const [destinationSubmapel, setDestinationSubmapel] = useState(destinationClassId ? destinationClassId : null)
  const [sharedClasses, setSharedClasses] = useState([])
  const [listSubmapel, setListSubmapel] = useState([])
  const [selectedData, setSelectedData] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)
  const debounceTimeout = useRef(null)

  /* ========================================= Functions ======================================== */
  async function getCategoryActive() {
    const response = await getRequest('categories-active')
    if (response) {
      let temp = response.data.map((item) => ({
        label: item.title,
        value: item.id,
      }))
      setAllCategory(temp)
    }
  }

  async function getClassProfiles() {
    try {
      setIsLoading(true)
      const response = await getRequest(
        `classes-profiles?${categoryId ? `category_id=${categoryId}` : ''}`
      )
      if (response) {
        setAllClassProfiles(response?.data || [])
      }
    } finally {
      setIsLoading(false)
    }
  }

  async function getListSubmapel(search = '') {
    const response = await getRequest(
      `classes?role_type=${role_active?.role_type || undefined}&limit=999&offset=0${search ? `&search=${search}` : ''}`,
    )
    if (response) {
      let temp = []
      if (Array.isArray(response?.data) && response?.data?.length) {
        response.data.map((item) => {
          let isOwner = false
          let isDuplicate = false

          if (Array.isArray(item?.class_profiles) && item?.class_profiles?.length) {
            isOwner = item?.class_profiles?.find(
              (cp) => cp?.is_owner == false && cp?.status == 'approved',
            )
            item.is_owner = isOwner ? false : true

            isDuplicate = item?.class_profiles?.[0]?.status == 'duplicate'
          } else if (typeof item?.class_profiles === 'object') {
            isDuplicate = item?.class_profiles?.status == 'duplicate'
          }

          temp.push({
            label: item.title ? item.title : '',
            value: item.id,
            isOwner: isOwner,
            isDuplicate: isDuplicate,
            profileName: item?.profile?.name
          })
        })

        setListSubmapel(temp)
      } else {
        setListSubmapel([])
      }
    }
  }

  async function handleSave() {
    setIsLoadingSubmit(true)
    let form = {
      destination_class_id: destinationSubmapel,
      classes: sharedClasses,
    }
    let response = await postRequest('share-classes-v2', form)
    if (response) {
      setDestinationSubmapel(null)
      setSelectedData(null)
      setSharedClasses([])
      setIsLoadingSubmit(false)
      window.notification('Sub Mata Pelajaran', 'berhasil diduplikasi', 'success')

      if (isPopUp) {
        window.close()
        window.opener.location.reload()
      }
    }
    setIsLoadingSubmit(false)
  }

  async function handleClick(item) {
    setSelectedData(item)
    window.$('#modal-content-submapel').modal('show')
  }

  async function handleClose() {
    setSelectedData(null)
  }

  /* ========================================== Effects ========================================= */
  useEffect(() => {
    getListSubmapel()
    getCategoryActive()
  }, [])

  useEffect(() => {
    getClassProfiles()
  }, [categoryId])

  /* ========================================== Output ========================================== */
  return (
    <TemplateAdmin>
      <Container>
        <Header pageName="Bagikan Sub Mata Pelajaran" />

        <div className="row">
          <div className="col-sm-12">
            <div className="card user-profile-list">
              <div className="card-header">
                <div className="row align-items-center">
                  <div className="col-md-6 col-sm-12">
                    <h5>Kelola Sub Mata Pelajaran</h5>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <button
                      onClick={() => handleSave()}
                      disabled={isLoading || isLoadingSubmit || !sharedClasses?.length || !destinationSubmapel}
                      type="button"
                      className="btn btn-success has-ripple float-right"
                    >
                      {isLoadingSubmit ? (
                        <div
                          className="spinner-border"
                          role="status"
                        >
                          <span className="visually-hidden"></span>
                        </div>
                      ) : (
                        <span>Simpan</span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div className='row'>
                  <div className="col-md-4 mb-3 mb-md-0">
                    <span className="f`-w-700 f-14">Submapel Tujuan</span>
                    <BaseSelect
                      className="mt-2"
                      placeholder="Pilih Submapel Tujuan"
                      noOptionsMessage={() => 'Data submapel tidak ditemukan'}
                      isMulti={false}
                      isClearable={true}
                      isSearchable={true}
                      filterOption={null}
                      formatOptionLabel={(option) => (
                        <span>
                          {option?.isOwner && (
                            <span className="badge badge-dark mr-1">
                              Shared {option.profileName ? `by ${option.profileName}` : ''}
                            </span>
                          )}
                          {option?.isDuplicate && (
                            <span className="badge badge-info mr-1">
                              Duplicate {option.profileName ? `by ${option.profileName}` : ''}
                            </span>
                          )}
                          {option?.label}
                        </span>
                      )}
                      onInputChange={(val, action) => {
                        if (action.action === 'input-change') {
                          if (debounceTimeout.current) {
                            clearTimeout(debounceTimeout.current)
                          }
                          debounceTimeout.current = setTimeout(() => {
                            getListSubmapel(val)
                          }, 500)
                        }
                      }}
                      options={listSubmapel}
                      value={listSubmapel.find(item => item.value === destinationSubmapel) || null}
                      onChange={(value) => {
                        setDestinationSubmapel(value?.value || null)
                      }}
                    />
                  </div>

                  {destinationSubmapel ? (
                    <>
                      <div className="col-md-4 mb-3 mb-md-0">
                        <span className="f-w-700 f-14">
                          Filter Mata Pelajaran
                        </span>
                        <Select
                          isClearable
                          className="mt-2"
                          placeholder="Pilih mata pelajaran"
                          isMulti={false}
                          options={allCategory}
                          onChange={(v) => setCategoryId(v ? v.value : '')}
                        />
                      </div>
                    </>
                  ) : null}
                </div>

                <hr />

                {destinationSubmapel ? (
                  <>
                    {isLoading ? (
                      <LoadingSpinner />
                    ) : null}

                    {!isLoading && allClassProfiles?.length ? allClassProfiles.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className="mt-4"
                        >
                          <h5>
                            {item.title}{' '}
                            <small>- {item.categories_type?.type}</small>
                          </h5>
                          {item.class_profiles.map((items, idx) => {
                            items = items.class

                            const active = sharedClasses.some(v => v.id == items.id)

                            return (
                              <button
                                onClick={() => handleClick(items)}
                                key={idx}
                                className={`btn ${active
                                  ? 'btn-primary'
                                  : 'btn-outline-secondary'
                                  } m-1`}
                              >
                                {items.title}
                              </button>
                            )
                          })}
                        </div>
                      )
                    }) : null}

                    {!isLoading && !allClassProfiles?.length ? (
                      <div className="text-center">
                        Belum ada data
                      </div>
                    ) : null}
                  </>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <ModalContentSubmapel
          id="modal-content-submapel"
          selectedData={selectedData}
          onSave={(selectedContent) => setSharedClasses(selectedContent)}
          onClose={() => handleClose()}
        />
      </Container>
    </TemplateAdmin>
  )
}
